module.exports = __webpack_public_path__ + "static/media/heroimage_igib-019.530915aa.jpg";